import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M2.2 1.2h13.6v1.6H17V0H1v2.8h1.2V1.2zm6.797 15.546c-1.671-.527-3.892-1.563-5.333-3.546H2.24C3.624 15.551 6.058 17.151 9 18a11.096 11.096 0 0 0 6.329-4.8h-1.457a9.87 9.87 0 0 1-4.875 3.546zM16.5 4h-15C.675 4 0 4.675 0 5.5v5c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5v-5c0-.825-.675-1.5-1.5-1.5zm.3 6.5c0 .163-.137.3-.3.3h-15a.304.304 0 0 1-.3-.3v-5c0-.163.137-.3.3-.3h15c.163 0 .3.137.3.3v5zM12 9h3V7.8h-3V9zM4.3 6.7a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6zm4.7 0a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6z" />
  </svg>
);

export default SvgComponent;
